import React from 'react';
import ChatListItem from './ChatListItem';

const ChatList = ({ chatList, selectedChatId, handleChatSelect }) => {
  return (
    <div className="overflow-auto flex-1">
      <ul className="p-0">
        {chatList.map(chatItem => (
          <ChatListItem 
            key={chatItem.chat_id}
            chatItem={chatItem}
            isSelected={selectedChatId === chatItem.chat_id}
            onClick={() => handleChatSelect(chatItem)}
          />
        ))}
      </ul>
    </div>
  );
};

export default ChatList;
